import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STEPS = [
  { n: "01", t: "Create your parent account", d: "Just an email and a password — takes 30 seconds." },
  { n: "02", t: "Add one or more students", d: "Multiple kids? Multiple campuses? Manage them all from one place." },
  { n: "03", t: "Add the apartment or dorm", d: "Tell us whether it's a dorm, full apartment, or an individually-leased bedroom." },
  { n: "04", t: "Pick the cleaning cadence", d: "Weekly, bi-weekly, monthly — or a single move-in / move-out clean." },
  { n: "05", t: "Choose optional common areas", d: "Add the kitchen, living room or shared bathroom if you'd like them included." },
  { n: "06", t: "Pay securely with Stripe", d: "Cards, Apple Pay, Google Pay. Recurring billing is automatic." },
  { n: "07", t: "We clean. We photograph. We report.", d: "After every visit you get a detailed report with photos and condition scores." },
  { n: "08", t: "Reschedule or cancel any time", d: "Life happens. We're flexible." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <Badge variant="outline" className="mb-3">How it works</Badge>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-primary">From "is the room clean?" to "I know it's clean."</h1>
      <p className="mt-4 text-muted-foreground">Here's exactly what happens when you sign up.</p>

      <div className="mt-12 space-y-4">
        {STEPS.map((s) => (
          <Card key={s.n} className="border-border/60">
            <CardContent className="p-6 flex gap-6 items-start">
              <div className="font-display text-4xl font-bold text-secondary/80 w-16 flex-shrink-0">{s.n}</div>
              <div>
                <div className="font-display font-semibold text-lg text-primary">{s.t}</div>
                <p className="text-sm text-muted-foreground mt-1">{s.d}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-12 text-center">
        <Button asChild size="lg" className="bg-primary hover:bg-primary/90 rounded-full px-8">
          <Link to="/booking">Start booking</Link>
        </Button>
      </div>
    </div>
  );
}
